import { FlaskConical } from 'lucide-react';
import { useDashboardBootstrap } from '@/hooks/useDashboardBootstrap';

export function DemoEnvironmentBanner() {
  const bootstrapQuery = useDashboardBootstrap();

  if (bootstrapQuery.data?.systemStatus?.environment !== 'demo') {
    return null;
  }

  return (
    <aside
      aria-label="Demo environment"
      className="border-warning/50 bg-warning/10 text-warning flex shrink-0 items-center justify-center gap-2 border-b px-3 py-1.5 text-xs"
    >
      <FlaskConical className="h-3.5 w-3.5" aria-hidden="true" />
      <strong>Isolated demo</strong>
      <span className="text-warning/85">
        Showcase data is disposable and may be reset between demonstrations.
      </span>
    </aside>
  );
}
